<template>
  <v-card class="mt-3 filter-report" flat>
    <v-card-actions class="mb-3 pa-0">
      <v-btn color="primary" @click="csvExport">
        <v-icon left>cloud_download</v-icon>
        Export report to csv
      </v-btn>
      <v-spacer />
    </v-card-actions>

    <v-data-table
      :headers="headers"
      :items="items"
      :options.sync="pagination"
      :items-per-page="rowsPerPageItems"
      :loading="loading"
    >
      <template v-slot:body="{ items }">
        <tbody>
          <tr v-for="item in items" :key="item.name">
            <td
              v-for="header in headers"
              :class="[
                header.align && header.align === 'center'
                  ? 'text-center'
                  : 'text-left'
              ]"
              :key="item.id + '-' + header.value"
            >
              {{ item[header.value] }}
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
    <!-- <div class="text-center">
      <v-pagination
        v-model="pagination.page"
        :length="pageCount"
      ></v-pagination>
    </div> -->
  </v-card>
</template>

<script>
export default {
  props: ['headers', 'items', 'loading'],
  data() {
    return {
      selected: [],
      rowsPerPageItems: 15,
      pagination: {
        rowsPerPageItems: 15
      },
      pageCount: 0
    }
  },
  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0

      return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
    }
  },
  mounted() {
    if (this.$store.state.isSDECC == 1) {
      if (this.headers[5].text === 'Students % improvement') {
        this.headers[5].text = '% improvement'
      }
    }
  },
  methods: {
    csvExport() {
      this.$emit('csvExport')
    }
  }
}
</script>

<style lang="scss">
.filter-report {
  width: 100%;

  .v-datatable__actions__range-controls {
    display: none !important;
  }

  h2 {
    display: block;
    width: 100%;
  }

  p {
    padding: 0;
    margin: 0;
  }
}
</style>
